import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Select, Col, Row, Upload, notification, Button } from 'antd';
import propTypes from 'prop-types';
import { Modal } from '../../components/modals/antd-modals';
import GetSnippetsData from '../../../src/container/profile/authentication/overview/Snippets/GetSnippetsData';
import { BasicFormWrapper } from '../styled';
import userServices from '../../../src/services/userServices';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2'
import FeatherIcon from 'feather-icons-react';
import 'react-phone-input-2/lib/style.css'

const { Option } = Select;
const dateFormat = 'MM/DD/YYYY';
const { Dragger } = Upload;
const { TextArea } = Input;

const CreateMerchant = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const UID = useSelector((state) => {
    return state.fb.auth.uid;
  });


  const Base64Data = useSelector((state) => {
    return state.Base64Reducer.data
  })

  const role = "City"
  const snippetData = GetSnippetsData(role)


  const [form] = Form.useForm();
  const formData = new FormData();

  const [buttonDisable, setButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [namelength, setNamelength] = useState(0)
  const [biolength, setBiolength] = useState(0)

  const [phone, setPhone] = useState('')
  const [bio, SetBio] = useState("")

  const handleCountryCode = (value, data, event, formattedValue) => {
    setPhone(formattedValue)
  }


  const [state, setState] = useState({
    values: null,
    checked: null,
    visible
  });


  useEffect(() => {
    sessionStorage.removeItem('tab-index');
    let unmounted = false;
    if (!unmounted) {
      setState({
        visible,
      });
    }
    return () => {
      unmounted = true;
    };
  }, [visible]);

  function removeHtmlTags(str) {
    str = str.replace(/<[^>]*>/g, '');
    return str.replace(/&nbsp;/g, '');
  }

  const assign_bio = value => {
    const cleanedString = removeHtmlTags(value);
    setBiolength(cleanedString.length)
    SetBio(value);
  }

  const handleOk = (values) => {

    setButton(true);
    setLoading(true);

    setState({
      ...state,
      isLoading: true,
    });

    let post_data = { ...values, phone: phone, bio: bio };
    const data = userServices.SignUp(post_data).then(response => {
      if (response.data.status == true) {
        notification.success({
          message: response.data.message
        });
        setButton(false);
        setLoading(false);
        onCancel();
      } else {
        notification.warning({
          message: response.data.message
        });
        setButton(false);
        setLoading(false);
      }
    }).
      catch(error => {
        if (error.response && error.response.status === 400) {
          console.log("Error 400: Bad Request");
        } else {
          console.error("An error occurred:", error);
        }
      });

  };



  const handleCancel = () => {
    onCancel();
  };

  const showModal = () => {
    setImagesModalVisiable(true);
  }
  const onImageCancel = () => {
    setImagesModalVisiable(false);
  }


  const SetEditorData = value => {
    //alert(value);
    //const cleanedString = removeHtmlTags(value);
    //SetDescriptionLength(cleanedString.length)
    SetDescription(value);
  }

  return (

    <>

      <Modal
        type={state.modalType}
        title="Create Merchant"
        visible={state.visible}
        width={1000}
        backdrop="static"
        footer={[null]}
        onCancel={handleCancel}
      >
        <div className="project-modal">
          <BasicFormWrapper>
            <Form id="createWorkForm" form={form} name="createProject" onFinish={handleOk} encType="multipart/form-data">
              <Form.Item label="I am a..." name="i_am" initialValue="Merchant" style={{ display: 'none' }}>
                <Input readOnly
                />
              </Form.Item>
              <Form.Item label="Name" name="name" rules={[
                { required: true, message: 'Please input your full name' },
                { max: 100, message: "The maximum length for the full name is 100 characters." }
              ]}>

                <Input placeholder="Full name"
                  onChange={(e) => {
                    var temp = e.target.value;
                    setNamelength(temp.length);
                  }
                  }
                />
              </Form.Item>
              <div style={{ marginTop: '-25px', float: 'right' }} className={100 < namelength ? 'danger-text' : ''}>{namelength}/100 char used</div>

              <Form.Item
                name="email"
                label="Email Address"
                rules={[
                  { required: true, message: 'Please input your email address' },
                  { type: 'email', message: 'Please validate your email address' },
                  { max: 100, message: "The maximum length for the email is 100 characters." }
                ]}
              >
                <Input placeholder="name@example.com" />
              </Form.Item>

              <Row gutter={15}>
                <Col md={12} className="mb-25">
                  <Form.Item name="phone" label="Phone"
                    rules={[{ required: true, message: 'Please input your phone' }]}>
                    <PhoneInput
                      country={'us'}
                      inputProps={{
                        name: 'phone'
                      }}
                      inputStyle={{
                        height: '48px',
                        width: '100%'
                      }}
                      enableSearch={true}
                      copyNumbersOnly={false}
                      searchPlaceholder='search'
                      searchNotFound='No entries to show'
                      countryCodeEditable={false}
                      onChange={handleCountryCode}
                    />
                  </Form.Item>
                </Col>
                <Col md={12} className="mb-25">
                  <Form.Item name="city" label="City" rules={[{ required: true, message: 'Please select your city' }]}
                    tooltip={{
                      title: <p dangerouslySetInnerHTML={{ __html: snippetData != "" ? snippetData.CityContent : "Currently we are only in the Chicago area, please send us a message if you think your location would be a good fit for Stoodio." }}></p>,
                      icon: <FeatherIcon icon="help-circle" size={20} />,
                      overlayClassName: 'ant-tooltip-custom-width'
                    }}>
                    <Input placeholder="City name" />
                  </Form.Item>

                </Col>
              </Row>



              <Row gutter={15}>
                <Col md={12} className="mb-25">
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password' }]}
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>
                </Col>
                <Col md={12} className="mb-25">
                  <Form.Item
                    name="confirm"
                    label="Confirm Password"
                    dependencies={['password']}
                    rules={[
                      {
                        required: true,
                        message: 'Please confirm your password',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Your password entered do not match'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                </Col>
              </Row>

              <Form.Item
                label="Bio"
                name="bio"
                rules={[                  
                  { max: 5000, message: "The maximum length for the bio is 5000 characters." }]}
              >

                <Input.TextArea rows={4} type='text' onChange={(e) => assign_bio(e.target.value)} />

              </Form.Item>
              <div style={{ marginTop: '-25px', float: 'right' }} className={5000 < biolength ? 'danger-text' : ''}>{biolength}/5000 char used</div>

              <Form.Item>
                <Button type="primary" htmlType="submit" disabled={buttonDisable}>
                  Submit {loading && (<i className='fa fa-spinner fa-spin' style={{ fontSize: 18, marginLeft: 5 }} />)}
                </Button>
                {' '}
                <Button size="default" type="white" key="back" outlined onClick={handleCancel}>
                  Cancel
                </Button>
              </Form.Item>

            </Form>
          </BasicFormWrapper>
        </div>
      </Modal>
    </>
  );
};

CreateMerchant.propTypes = {
  visible: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};

export default CreateMerchant;
